// Time window for key rotation in seconds (15 minutes)
export const TIME_WINDOW_SECONDS = 15 * 60;

// Mask for obfuscating time blocks
export const TIME_OBFUSCATION_MASK = 0xabcdef;

// UUID for the routes discovery endpoint
export const ROUTES_DISCOVERY_UUID = "7b9e4f2a-3c5d-4a8b-9e1f-2d6c8b9a5e3f";

// Retry configuration for routes discovery
export const ROUTES_DISCOVERY_RETRY_ATTEMPTS = 3;
export const ROUTES_DISCOVERY_RETRY_DELAY = 1000; // milliseconds
